
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33928',
  depVersions: {
  "documents-public-ui": "static-1.33928",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33933",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1909",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5375",
  "hs-test-utils": "static-1.7788",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11206",
  "I18n": "static-7.1564",
  "jasmine-immutable": "static-1.2801",
  "jasmine-runner": "static-1.6255",
  "lodash": "static-1.3",
  "quartz": "static-1.6703",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16426",
  "reporting-data": "static-1.66450",
  "reporting-testing-lib": "static-1.8383",
  "reporting-visualizations": "static-1.58526",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4549",
  "webpack-env": "static-1.54",
  "atom": "static-1.4853",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2267",
  "classnames": "static-2.10",
  "cssUtils": "static-1.726",
  "customer-data-filters-ui": "static-1.38847",
  "customer-data-objects": "static-1.7429",
  "customer-data-property-utils": "static-1.7855",
  "data-fetching-client": "static-1.9462",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4312",
  "flux-actions": "static-1.306",
  "FormsCommonComponents": "static-1.85256",
  "FormUrlGenerator": "static-2.4513",
  "foundations-components": "static-1.7491",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11514",
  "icons": "static-2.620",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6945",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3642",
  "property-translator": "static-1.5196",
  "quartz-config": "static-1.481",
  "quartz-core": "static-1.5922",
  "quick-fetch": "static-1.3718",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5157",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7944",
  "reference-resolvers-lite": "static-1.7874",
  "report-customization-components": "static-1.12458",
  "reporting-enablement": "static-1.22018",
  "reporting-reports": "static-1.66128",
  "reporting-snowflake": "static-1.55068",
  "reporting-ui-components": "static-2.63721",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4415",
  "sales-content-partitioning": "static-1.8718",
  "SalesContentIndexUI": "static-3.8874",
  "sanitize": "static-1.4258",
  "sanitize-text": "static-1.7922",
  "self-service-api": "static-1.10019",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1537",
  "signup-constants": "static-1.18350",
  "signup-ui-lego-core": "static-1.20360",
  "signup-ui-url-generator": "static-2.7851",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4554",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10777",
  "ui-addon-i18n": "static-1.10918",
  "ui-addon-react-router-dom": "static-1.9331",
  "ui-addon-upgrades": "static-9.17626",
  "ui-asset-management-lib": "static-1.10685",
  "ui-images": "static-2.1087",
  "UIComponents": "static-3.8153",
  "usage-tracker": "static-1.7115",
  "usage-tracker-container": "static-1.7105",
  "usage-tracker-core": "static-1.6965",
  "usage-tracker-public": "static-1.6926",
  "viral-links-lib": "static-1.6816",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3211",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2980",
  "quartz-webpack": "static-1.2927",
  "ai-components-ui-library": "static-1.8304",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4618",
  "foundations-theming": "static-1.4193",
  "quartz-auth": "static-1.378",
  "usage-tracker-session-replay": "static-1.4801",
  "foundations-theming-base": "static-1.3178",
  "HeadJS": "static-2.706",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2899",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4111",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7707",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3401",
  "persist-promise": "static-1.3489",
  "reporting-client-types": "static-1.2384",
  "foundations-components-legacy": "static-1.516",
  "hs-story-utils": "static-1.9211",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9439",
  "hubspotter-http": "static-1.4461",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7031",
  "crm-message-bus": "static-1.42310",
  "customer-data-filters-ui-msw-helpers": "static-1.21281",
  "customer-data-objects-ui-components": "static-1.12788",
  "customer-data-reference-ui-components": "static-1.12925",
  "customer-data-ui-utilities": "static-1.9607",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6558",
  "framework-data-schema-resolvers": "static-1.6653",
  "inbound-db-properties-service-client": "static-1.3659",
  "multi-account-reference-resolvers": "static-1.754",
  "onboarding-tours": "static-1.16231",
  "reporting-datasets-permissions-lib": "static-1.12990",
  "ui-addon-teams": "static-1.21217",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67575",
  "customer-data-properties": "static-1.50755",
  "forms-ai-lib": "static-1.3986",
  "forms-utils-lib": "static-1.12137",
  "foundations-components-test-utils": "static-1.4974",
  "react-dnd-compat": "static-1.4405",
  "react-tinymce": "static-1.54574",
  "tinymce-config": "static-2.53700",
  "ui-gdpr-components": "static-1.10130",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3760",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1142",
  "ui-fonts": "static-1.468",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.789",
  "mobile-manifest-mixins": "static-1.479",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.368",
  "quartz-i18n": "static-1.378",
  "quartz-routing": "static-1.133",
  "quartz-test": "static-1.378",
  "batch-promise": "static-1.1332",
  "external-options-client-types": "static-1.3968",
  "react-colorpicker": "static-2.9993",
  "copilot-toolkit": "static-1.10480",
  "data-quality-ui-library": "static-1.12281",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40615",
  "reporting-insights-lib": "static-1.1116",
  "reporting-plugins": "static-1.9959",
  "ui-addon-draggable-compat": "static-2.4036",
  "ui-addon-opt": "static-4.8168",
  "ui-shepherd-react": "static-3.9928",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24685",
  "hubspot-apollo-client": "static-1.4662",
  "sales-templates-service-types-lib": "static-1.3978",
  "ui-business-units-lib": "static-1.8809",
  "merchandise-lib": "static-1.258",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5459",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3887",
  "timezone-utils": "static-2.5027",
  "bender-build-tools": "static-1.2926",
  "chatspot-core": "static-1.20238",
  "chirp-fetch": "static-1.1666",
  "bend-plugin-foundations-theming": "static-1.2676",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9437",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3607",
  "crm-pipelines-api-client-types": "static-1.3948",
  "multi-currency-client-types": "static-1.3501",
  "getting-started-shared-tasks": "static-1.17838",
  "growth-data-modal": "static-1.5133",
  "growth-onboarding-confetti": "static-1.2853",
  "growth-onboarding-next-action-utils": "static-1.1279",
  "navigation-components": "static-1.17216",
  "onboarding-tours-client": "static-1.4445",
  "onboarding-tours-utils": "static-1.297",
  "ui-shepherd-tracker": "static-1.7309",
  "ui-universal-auth": "static-1.8667",
  "user-context": "static-1.4878",
  "cms-field-types": "static-1.4588",
  "content-icons-ui": "static-1.2148",
  "integrations-lib": "static-1.15364",
  "calling-global-api": "static-1.63598",
  "calling-internal-common": "static-1.31073",
  "calling-lifecycle-internal": "static-1.64980",
  "calling-lifecycle-messages": "static-1.57274",
  "commerce-products-lib": "static-1.8815",
  "crm-links": "static-1.6040",
  "file-manager-components": "static-1.22837",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.458",
  "inbounddb-objects-service-types": "static-1.4033",
  "meetings-icalendar-utils-lib": "static-1.416",
  "object-builder-ui-client": "static-1.47915",
  "pipeline-validation-client-types": "static-1.3770",
  "property-value-citations": "static-1.1369",
  "pulse": "static-1.290",
  "smart-property-lib": "static-1.5837",
  "tiered-pricing": "static-1.803",
  "ui-addon-iframeable": "static-1.8825",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19442",
  "tinymce-themes": "static-1.55670",
  "data-token-picker": "static-1.16014",
  "hub-http-contrib": "static-1.2828",
  "interframe": "static-3.4574",
  "tinymce-data": "static-1.39785",
  "tinymce-plugins": "static-1.56814",
  "ui-addon-sales-email": "static-1.4995",
  "magpie-lib": "static-1.5377",
  "magpie-types": "static-1.4837",
  "simple-logging-lib": "static-1.2833",
  "content-assistance-lib": "static-1.7424",
  "dashboard-lib": "static-1.80563",
  "ExportDialog": "static-6.10169",
  "hubspot-prosemirror": "static-1.17564",
  "hubspot-prosemirror-plugins": "static-1.17556",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8475",
  "campaign-roi-lib": "static-1.8224",
  "feedback-loader": "static-1.28822",
  "onboarding-scopes": "static-1.6246",
  "apollo-link-hub-http": "static-2.4431",
  "hubspot-apollo-cache": "static-1.121",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2139",
  "purchase-motions-api": "static-1.5462",
  "trials-service-types": "static-1.3702",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.508",
  "unified-auth-core-lib": "static-1.462",
  "getting-started-shared-tasks-store": "static-1.16956",
  "integrations-error-boundary-lib": "static-1.12779",
  "integrations-tracking-lib": "static-1.5368",
  "native-integrations-shared-strings": "static-1.7571",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10156",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31079",
  "shared-worker-versioning": "static-1.10820",
  "calling-usage-tracker": "static-1.6321",
  "voice-sms-access-library": "static-1.199",
  "customer-data-tracking": "static-1.6664",
  "products-iframe-lib": "static-1.7269",
  "products-ui-components-shared-msw-handlers": "static-1.9821",
  "location-customization-utils-lib": "static-1.8512",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3937",
  "video-components-external": "static-1.10513",
  "video-data-lib": "static-1.34171",
  "directed-graph": "static-1.720",
  "event-emitter": "static-1.730",
  "breeze-intelligence-kit": "static-1.5297",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9522",
  "fsm": "static-1.3514",
  "policy-lib": "static-1.6565",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9585",
  "navigation-messaging": "static-1.6543",
  "FileManagerLib": "static-1.38477",
  "NamespacedHubStyle": "static-2.8880",
  "FileManagerCore": "static-1.38336",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12002",
  "layout-dnd-utils": "static-1.10977",
  "react-codemirror": "static-1.10409",
  "ui-addon-emoji-picker": "static-1.9672",
  "ui-brand-identity-lib": "static-1.13785",
  "ui-addon-video-player": "static-1.8478",
  "ui-coaching-tips": "static-1.27901",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8352",
  "payment-link-components": "static-1.22898",
  "EmailSignatureEditor": "static-1.23872",
  "eligibility-engine-service-types": "static-1.2983",
  "universal-page-editor-lib": "static-1.2781",
  "calling-orchestration-schema": "static-1.34976",
  "sales-views-client-types": "static-1.4075",
  "crm-record-cards-service-types": "static-1.3436",
  "content-media-composition-data-lib": "static-1.11388",
  "content-media-compositions": "static-2.15395",
  "media-bridge-lib": "static-1.18536",
  "trellis-story-utils": "static-1.4306",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5588",
  "FileManagerImages": "static-1.35988",
  "video-components": "static-1.12516",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4316",
  "video-embed": "static-1.35005",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67650",
  "layout-data-lib": "static-1.9302",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6368",
  "commerce-tours-lib": "static-1.5691",
  "growth-onboarding-reliability": "static-1.4870",
  "sales-checkout-service-client": "static-1.3461",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21280",
  "sales-email-signature-service-client": "static-1.3628",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21277",
  "outpost": "static-1.3988",
  "advanced-menus-core": "static-1.14787",
  "advanced-menus-lib": "static-1.11766",
  "ui-memberships-settings-lib": "static-1.33384",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14786",
  "simple-menus-lib": "static-1.16303"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33928",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33933",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1909",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5375",
  "hs-test-utils": "/hs-test-utils/static-1.7788",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11206",
  "I18n": "/I18n/static-7.1564",
  "jasmine-immutable": "/jasmine-immutable/static-1.2801",
  "jasmine-runner": "/jasmine-runner/static-1.6255",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6703",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16426",
  "reporting-data": "/reporting-data/static-1.66450",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8383",
  "reporting-visualizations": "/reporting-visualizations/static-1.58526",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4549",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4853",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2267",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.726",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38847",
  "customer-data-objects": "/customer-data-objects/static-1.7429",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7855",
  "data-fetching-client": "/data-fetching-client/static-1.9462",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4312",
  "flux-actions": "/flux-actions/static-1.306",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85256",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4513",
  "foundations-components": "/foundations-components/static-1.7491",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11514",
  "icons": "/icons/static-2.620",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6945",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3642",
  "property-translator": "/property-translator/static-1.5196",
  "quartz-config": "/quartz-config/static-1.481",
  "quartz-core": "/quartz-core/static-1.5922",
  "quick-fetch": "/quick-fetch/static-1.3718",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5157",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7944",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7874",
  "report-customization-components": "/report-customization-components/static-1.12458",
  "reporting-enablement": "/reporting-enablement/static-1.22018",
  "reporting-reports": "/reporting-reports/static-1.66128",
  "reporting-snowflake": "/reporting-snowflake/static-1.55068",
  "reporting-ui-components": "/reporting-ui-components/static-2.63721",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4415",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8718",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8874",
  "sanitize": "/sanitize/static-1.4258",
  "sanitize-text": "/sanitize-text/static-1.7922",
  "self-service-api": "/self-service-api/static-1.10019",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1537",
  "signup-constants": "/signup-constants/static-1.18350",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20360",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7851",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4554",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10777",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10918",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9331",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17626",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10685",
  "ui-images": "/ui-images/static-2.1087",
  "UIComponents": "/UIComponents/static-3.8153",
  "usage-tracker": "/usage-tracker/static-1.7115",
  "usage-tracker-container": "/usage-tracker-container/static-1.7105",
  "usage-tracker-core": "/usage-tracker-core/static-1.6965",
  "usage-tracker-public": "/usage-tracker-public/static-1.6926",
  "viral-links-lib": "/viral-links-lib/static-1.6816",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3211",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2980",
  "quartz-webpack": "/quartz-webpack/static-1.2927",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8304",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4618",
  "foundations-theming": "/foundations-theming/static-1.4193",
  "quartz-auth": "/quartz-auth/static-1.378",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4801",
  "foundations-theming-base": "/foundations-theming-base/static-1.3178",
  "HeadJS": "/HeadJS/static-2.706",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2899",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4111",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7707",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3401",
  "persist-promise": "/persist-promise/static-1.3489",
  "reporting-client-types": "/reporting-client-types/static-1.2384",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.516",
  "hs-story-utils": "/hs-story-utils/static-1.9211",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9439",
  "hubspotter-http": "/hubspotter-http/static-1.4461",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7031",
  "crm-message-bus": "/crm-message-bus/static-1.42310",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21281",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12788",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12925",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9607",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6558",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6653",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3659",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.754",
  "onboarding-tours": "/onboarding-tours/static-1.16231",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12990",
  "ui-addon-teams": "/ui-addon-teams/static-1.21217",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67575",
  "customer-data-properties": "/customer-data-properties/static-1.50755",
  "forms-ai-lib": "/forms-ai-lib/static-1.3986",
  "forms-utils-lib": "/forms-utils-lib/static-1.12137",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4974",
  "react-dnd-compat": "/react-dnd-compat/static-1.4405",
  "react-tinymce": "/react-tinymce/static-1.54574",
  "tinymce-config": "/tinymce-config/static-2.53700",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10130",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3760",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1142",
  "ui-fonts": "/ui-fonts/static-1.468",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.789",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.479",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.368",
  "quartz-i18n": "/quartz-i18n/static-1.378",
  "quartz-routing": "/quartz-routing/static-1.133",
  "quartz-test": "/quartz-test/static-1.378",
  "batch-promise": "/batch-promise/static-1.1332",
  "external-options-client-types": "/external-options-client-types/static-1.3968",
  "react-colorpicker": "/react-colorpicker/static-2.9993",
  "copilot-toolkit": "/copilot-toolkit/static-1.10480",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12281",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40615",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1116",
  "reporting-plugins": "/reporting-plugins/static-1.9959",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4036",
  "ui-addon-opt": "/ui-addon-opt/static-4.8168",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9928",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24685",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4662",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3978",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8809",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5459",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3887",
  "timezone-utils": "/timezone-utils/static-2.5027",
  "bender-build-tools": "/bender-build-tools/static-1.2926",
  "chatspot-core": "/chatspot-core/static-1.20238",
  "chirp-fetch": "/chirp-fetch/static-1.1666",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2676",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9437",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3607",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3948",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3501",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17838",
  "growth-data-modal": "/growth-data-modal/static-1.5133",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2853",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1279",
  "navigation-components": "/navigation-components/static-1.17216",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4445",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.297",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7309",
  "ui-universal-auth": "/ui-universal-auth/static-1.8667",
  "user-context": "/user-context/static-1.4878",
  "cms-field-types": "/cms-field-types/static-1.4588",
  "content-icons-ui": "/content-icons-ui/static-1.2148",
  "integrations-lib": "/integrations-lib/static-1.15364",
  "calling-global-api": "/calling-global-api/static-1.63598",
  "calling-internal-common": "/calling-internal-common/static-1.31073",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64980",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57274",
  "commerce-products-lib": "/commerce-products-lib/static-1.8815",
  "crm-links": "/crm-links/static-1.6040",
  "file-manager-components": "/file-manager-components/static-1.22837",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.458",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4033",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.416",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47915",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3770",
  "property-value-citations": "/property-value-citations/static-1.1369",
  "pulse": "/pulse/static-1.290",
  "smart-property-lib": "/smart-property-lib/static-1.5837",
  "tiered-pricing": "/tiered-pricing/static-1.803",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8825",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19442",
  "tinymce-themes": "/tinymce-themes/static-1.55670",
  "data-token-picker": "/data-token-picker/static-1.16014",
  "hub-http-contrib": "/hub-http-contrib/static-1.2828",
  "interframe": "/interframe/static-3.4574",
  "tinymce-data": "/tinymce-data/static-1.39785",
  "tinymce-plugins": "/tinymce-plugins/static-1.56814",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4995",
  "magpie-lib": "/magpie-lib/static-1.5377",
  "magpie-types": "/magpie-types/static-1.4837",
  "simple-logging-lib": "/simple-logging-lib/static-1.2833",
  "content-assistance-lib": "/content-assistance-lib/static-1.7424",
  "dashboard-lib": "/dashboard-lib/static-1.80563",
  "ExportDialog": "/ExportDialog/static-6.10169",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17564",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17556",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8475",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8224",
  "feedback-loader": "/feedback-loader/static-1.28822",
  "onboarding-scopes": "/onboarding-scopes/static-1.6246",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4431",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.121",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2139",
  "purchase-motions-api": "/purchase-motions-api/static-1.5462",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.508",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.462",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16956",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12779",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5368",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7571",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10156",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31079",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10820",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6321",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.199",
  "customer-data-tracking": "/customer-data-tracking/static-1.6664",
  "products-iframe-lib": "/products-iframe-lib/static-1.7269",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9821",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8512",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3937",
  "video-components-external": "/video-components-external/static-1.10513",
  "video-data-lib": "/video-data-lib/static-1.34171",
  "directed-graph": "/directed-graph/static-1.720",
  "event-emitter": "/event-emitter/static-1.730",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5297",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9522",
  "fsm": "/fsm/static-1.3514",
  "policy-lib": "/policy-lib/static-1.6565",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9585",
  "navigation-messaging": "/navigation-messaging/static-1.6543",
  "FileManagerLib": "/FileManagerLib/static-1.38477",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8880",
  "FileManagerCore": "/FileManagerCore/static-1.38336",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12002",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10977",
  "react-codemirror": "/react-codemirror/static-1.10409",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9672",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13785",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8478",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27901",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8352",
  "payment-link-components": "/payment-link-components/static-1.22898",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23872",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2781",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34976",
  "sales-views-client-types": "/sales-views-client-types/static-1.4075",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3436",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11388",
  "content-media-compositions": "/content-media-compositions/static-2.15395",
  "media-bridge-lib": "/media-bridge-lib/static-1.18536",
  "trellis-story-utils": "/trellis-story-utils/static-1.4306",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5588",
  "FileManagerImages": "/FileManagerImages/static-1.35988",
  "video-components": "/video-components/static-1.12516",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4316",
  "video-embed": "/video-embed/static-1.35005",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67650",
  "layout-data-lib": "/layout-data-lib/static-1.9302",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6368",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5691",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4870",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3461",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21280",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3628",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21277",
  "outpost": "/outpost/static-1.3988",
  "advanced-menus-core": "/advanced-menus-core/static-1.14787",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11766",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33384",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14786",
  "simple-menus-lib": "/simple-menus-lib/static-1.16303"
}
};
